export class MathExt {
  public static IsNegative(num: number): boolean {
    return Math.sign(num) == -1;
  }
}
